import { FC, ReactNode, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Collapse,
  Divider,
  IconButton,
  Typography
} from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';

interface CollapsibleSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
  // Rendered at the bottom of the section body, typically a save-button row.
  actions?: ReactNode;
}

// Presentational, titled section with an ExpandMore/ExpandLess toggle in its
// header, mirroring the Collapse pattern used in factor-concernings-panel.tsx.
export const CollapsibleSection: FC<CollapsibleSectionProps> = (props) => {
  const { title, defaultOpen = true, children, actions } = props;
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          py: 1
        }}
        onClick={() => setOpen(!open)}
      >
        <Typography variant="h6" sx={{ color: '#8F16C8' }}>
          {title}
        </Typography>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(!open);
          }}
        >
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>
      <Divider />
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ pt: 2 }}>
          {children}
          {actions && <Box sx={{ pt: 2 }}>{actions}</Box>}
        </Box>
      </Collapse>
    </Box>
  );
};

CollapsibleSection.propTypes = {
  // @ts-ignore
  title: PropTypes.string.isRequired,
  defaultOpen: PropTypes.bool,
  // @ts-ignore
  children: PropTypes.node,
  actions: PropTypes.node
};
